<template>
  <div class="panel panel-default">
    <div class="panel-heading">Limite Diário Por Usuário</div>
    <div class="panel-body">
      <form
        @submit.prevent="handleSubmit"
        name="company-limit-per-user">
        <div class="col-xs-6 padding-off">
          <money
            v-model="form.limit"
            v-bind="money"
            v-validate="'required|min_value:1'"
            :class="{ 'alert-danger': submitted && errors.has('limit') }"
            name="limit"
            class="form-control"></money>
            <span
              v-if="submitted && errors.has('limit')"
              class="theme-form-error-message">{{ errors.first('limit') }}</span>
        </div>
        <div class="col-xs-6 _pr-0">
          <button
            :disabled="loading"
            type="submit"
            class="btn-blue btn-block btn-small">
            Atualizar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'

export default {
  components: {
    Money
  },
  props: [
    'limit',
    'loading'
  ],
  mounted () {
    this.handleForm(this.limit)
  },
  watch: {
    limit (data) {
      this.handleForm(data)
    }
  },
  data () {
    return {
      submitted: false,
      form: {
        limit: 0
      },
      money: {
        decimal: ',',
        thousands: '.',
        // prefix: 'R$ ',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    handleForm (limit) {
      this.form.limit = limit
    },
    handleSubmit () {
      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.$emit('handleAction', 'postAdminCompanyUpdateDailyLimitPerUser', this.form)
        }
      }).catch(() => {
        this.submitted = false
      })
    }
  }
}
</script>
